$('body').on('click','.btn-remover-carrinho', function() {
	var $self = $(this);

	if ($self.data('enviando')) {
		return false;
	}

	var porcao_id = $self.data('porcao_id')|0;

	if (0 === porcao_id) return;


	try	{
		var callback = function(resp) {
			if (resp.redirect_url != undefined) {
				location.href = resp.redirect_url;
				return;
			}

			if (resp.popup_url != undefined) {
				$.fancybox.open([{
					href: resp.popup_url,
					type: ajax
				}],{});
				$.fancybox.hideLoading();
				$self.data('enviando',false);
			}

			if (resp.success) {
				location.reload(true);
				return;
			} else {
				alert(resp.msg);
				$.fancybox.hideLoading();
				$self.data('enviando',false);
			}
		};
		$self.data('enviando',true);
		$.ajax({
			url: 'carrinho/remove',
			type: 'post',
			dataType: 'json',
			data: {
				porcao_id: porcao_id
			},
			success: callback,
			error: function() {
				callback({
					success: false,
					msg: "Não foi possível remover o produto."
				});
			}
		});
		$.fancybox.showLoading();
	} catch (e) {
		console.log(e.message);
	}
});


//////////////////
// WEBPACK FOOTER
// ../src/carrinho/index.js
// module id = 68
// module chunks = 0